import React from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();

  return (
    <div className="flex flex-col items-center h-full pt-[3.5rem] text-lg font-garamond">
      {/* Name at the top */}
      <div className="text-[4rem] font-bold mb-[4rem]">
        [AZ]
      </div>

      {/* Navigation Links */}
      <nav className="flex flex-col space-y-[4rem] sm:space-y-[2.7rem] items-center font-serif font-bold">
        {[
          { name: "HOME", path: "/" },
          { name: "ABOUT", path: "/about" },
          { name: "PROJECTS", path: "/projects" },
          { name: "READING", path: "/reading" },
          { name: "CONTACT", path: "/contact" },
        ].map((link) => (
          <Link
            key={link.name}
            to={link.path}
            className={`text-[1.6rem] sm:text-[1.2rem]  ${
              location.pathname === link.path
                ? "text-black cursor-default"
                : "hover:text-blue-600 text-blue-800 underline"
            }`}
            aria-current={location.pathname === link.path ? "page" : undefined}
          >
            {link.name}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Navbar;
